import api from "api";
import { AvatarPicture1 } from "component/Avatar";
import BlockHeader from "component/BlockHeader/BlockHeader";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import stateMap from "store/stateMap";
import "./index.scss";
import update from "immutability-helper";
import { popinfo } from "component/Fancybox/Fancybox";
import store from "store/store";
import { PageCredential } from "component/PageCredential";

const PageInitiativeInsideSATMember = connect(stateMap)((props) => {
    const [isChecked, setIsChecked]   = useState(props.isChecked);

    useEffect(() => {
        setIsChecked(props.isChecked);
    }, [props.isChecked])

    return (
        <div className="component-sat-member text-sm">
            <div className="member-image">
                <AvatarPicture1 user={props.member}/>
            </div>
            <div className="member-name">
                <span className="member-name-wrapper">
                    {props.member.UserDisplayName}
                </span>
            </div>
            <div className="member-id">
                {
                    props.member.StudentID
                }
            </div>
            <div className="role-name text-xs">{props.member.RoleName}</div>
            {/* <div className="sat-point-achieved text-xs">{props.member.SATPoint} Points</div> */}
            <div className="bga-name text-xs">{
                props.member.BGA.length > 0 && props.member.BGA.map(RoleBGA => (
                    <span key={RoleBGA}>
                        - {
                            _.last(
                                store.getState().config.BGA[
                                    _.indexOf(_.map(store.getState().config.BGA, 0), RoleBGA )
                                ] || []
                            )
                        }<br/>
                    </span>
                ))
            }</div>
            <div className="checkbox">
                <input 
                    checked={isChecked}
                    onChange={e => {
                        setIsChecked(e.target.checked);
                        
                        props.onChecked.apply(null, [props.member, e.target.checked]);
                    }}
                    type="checkbox"/>
            </div>
        </div>
    )
})

const PageInitiativeInsideSAT = connect(stateMap)((props) => {
    const [members, setMembers]                     = useState(false);
    const [checkedMember, setCheckedMember]         = useState([]);
    const [highestPointOnly, setHighestPointOnly]   = useState(false);
    
    
    const ExportCSV = () => {
        let RequestDownload = popinfo('loading', 'Generate User List File', 'Please Wait');
            
        api('/Initiative/SATPointCandidate', 'post', {
            initiative_id       : props.initiative.initiative.InitiativeID
            ,member_ids         : checkedMember.length > 0 ? checkedMember : update([], {
                $set : _.map(members,'UserID')
            })
            ,high_point_only    : highestPointOnly
        }, 'Bearer ' + props.auth.token)
            .then(response => {
                RequestDownload.close();
                let element = document.createElement('a');
                element.setAttribute('href', response.url);
                element.setAttribute('download', response.name);
                element.style.display = 'none';
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            })
            .catch(error => {
                popinfo('error', 'Generate User List File', error, {}, RequestDownload);
            });
    }


    useEffect(() => {
        if(!props.initiative.initiative)
        {
            return;
        }

        if(!props.auth.user)
        {
            return;
        }

        api('/Initiative/SATPointCandidate', 'get', {
            initiative_id : props.initiative.initiative.InitiativeID
        }, 'Bearer ' + props.auth.token)
            .then(response => {
                setMembers(response.member);

                setCheckedMember(update([], {
                    $set : _.map(response.member,'UserID')
                }));
            })

    }, [props.initiative, props.auth.user]);


    return (
        <div className="initiative-inside-sat container">
            <PageCredential title={`${props.initiative.initiative.Title} | SAT Points`} />
            <div className="w-800 mx-auto">
                <BlockHeader title="Export SAT Point Candidate" desc="Mark fellow collaborators / creators who are eligible to be selected as candidates to get SAT Points. You can report the resulting excel file via BINUSMAYA to be processed into SAT Points"/>
                <div className="members-list-rail">
                    <ul className="members-list">
                        <li className="the-member" key="table-header">
                            <div className="component-sat-member text-sm">
                                <div className="member-image"></div>
                                <div className="member-name font-bold">
                                    Member Name
                                </div>
                                <div className="font-bold">NIM
                                </div>
                                <div className="font-bold">Role</div>
                                {/* <div className="font-bold">SAT Point</div> */}
                                <div className="font-bold">BINUS <br/>Graduate Attribute</div>
                                <div className="checkbox">
                                    <input onChange={e => {
                                        if(e.target.checked)
                                        {
                                            setCheckedMember(update([], {
                                                $set : _.map(members,'UserID')
                                            }));
                                        }
                                        else
                                        {
                                            setCheckedMember(update([], {
                                                $set : []
                                            }));
                                        }                    

                                    }} type="checkbox" />
                                </div>
                            </div>
                        </li>
                        {
                            members !== false && members.map((member, index) => 
                                {                                    
                                    return (
                                        <li key={member.reactKey} className="the-member">
                                            <PageInitiativeInsideSATMember 
                                                member={member}  
                                                isChecked={checkedMember.indexOf(member.UserID) > -1}
                                                onChecked={(member, isChecked) => {
        
                                                    if(isChecked)
                                                    {
                                                        setCheckedMember(update(checkedMember, {
                                                            $push : [member.UserID]
                                                        }));
                                                    }
                                                    else
                                                    {
                                                        let pos = checkedMember.indexOf(member.UserID);
        
                                                        if(pos > -1)
                                                        {
                                                            setCheckedMember(update(checkedMember, {
                                                                $splice : [[pos, 1]]
                                                            }));
                                                        }
                                                    }
                                                }}
                                            />
                                        </li>
                                    )
                                }
                            )
                        }
                    </ul>
                </div>
                {
                    members !== false && 
                    <div className="text-right mt-lg">
                        {
                            members.length > 0 && 
                            <div>
                                {/* <button className="btn btn-small btn-primary btn-reverse" onClick={e => {
                                    e.preventDefault();

                                    setHighestPointOnly(true);

                                    ExportCSV();

                                }}>Export Highest SAT Point</button> */}
                                <button className="btn btn-small btn-primary" onClick={e => {
                                    e.preventDefault();

                                    setHighestPointOnly(false);

                                    ExportCSV();
                                    
                                }}>Export to CSV</button>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    )
})

export default PageInitiativeInsideSAT;